var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMz(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 512,
    width: 512,
    id: "flag-icon-css-mz",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.67,
    d: "M0 0h496.06v496.06H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    transform: "scale(1.0321)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#009a00",
    d: "M0 0h744.09v155.02H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#fff",
    d: "M0 154.98h744.09v15.52H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M0 170.5h744.09v155.02H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#fff",
    d: "M0 325.52h744.09v15.52H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#ffca00",
    d: "M0 341.04h744.09v155.02H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v496.06l325.56-248.03L0 0z",
    fillRule: "evenodd",
    fill: "red"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffca00",
    fillRule: "evenodd",
    d: "M192.351 322.606l-49.634-36.338-49.57 36.347 19.223-58.433-49.888-35.912 61.517.227 18.734-58.542 18.793 58.577 61.467-.28-49.903 35.974z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M99.635 281.854h35.756c2.877 3.228 9.296 4.544 15.41-.038 11.207-6.137 32.888.038 32.888.038l4.27-4.536-10.407-34.155-3.736-4.002s-8.005-4.803-23.215-3.202c-15.21 1.6-20.546-.533-20.546-.533s-13.342 1.6-17.078 3.468c-.41.333-4.269 4.27-4.269 4.27l-9.073 38.69z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 1.068,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M106.84 273.05s34.155-4.268 44.028 8.806c-5.576 3.815-10.485 4.13-15.743.268.837-1.396 12.274-13.342 41.36-9.34",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 1.068,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.395 238.897l-.265 37.624m30.684-37.094l6.404 29.885",
    stroke: "#000",
    strokeWidth: 1.14,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M113.33 238.956l-3.555 15.413",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 1.068,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M76.413 285.957l8.409 9.859c.987.589 1.864.551 2.741 0l12.462-14.954 5.234-6.48c.81-.96 1.07-2.031.997-2.991l10.006-8.892c.819.057 1.306.15 2.125.205-.967-.25-1.677-.722-.915-1.781l2.243-1.745 1.744 2.243s-2.492 3.24-2.741 3.24h-2.742l-5.234 4.736 2.288 2.022 3.445 9.443 4.237-2.991-2.742-9.72 5.982-6.48-2.243-3.49 1.495-1.994s20.703 13.034 28.68 9.545c.215.078.481-9.296.481-9.296s-21.434-2.243-21.933-6.48c-.499-4.237 4.736-4.735 4.736-4.735l-2.244-3.24.5-1.746 3.738 4.736 8.474-7.228 49.848 56.827c2.721-1.104 3.302-1.77 3.49-4.486-.07-.069-48.851-56.08-48.851-56.08l3.738-3.987c.737-.83.996-1.184.997-2.493l5.732-4.985c1.724.593 2.823 1.626 3.739 2.99l15.76-13.356c.415.416 1.677.831 2.533.364l26.052-25.012-28.394 20.058-1-.748c0-.83 1.03-1.036 0-2.492-1.103-1.324-2.742 1.246-2.99 1.246-.25 0-4.11-1.365-4.957-3.093l-.278 4.588-7.228 6.73-5.483-.25-7.976 7.727-.997 2.99 1.246 2.494s-4.237 3.738-4.237 3.489c0-.249-.857-1.102-.893-1.212l3.635-3.275.498-2.243-1.213-1.894c-.367.268-5.018 5.135-5.267 4.636-.42-.462-13.462-15.202-13.462-15.202l.747-2.742-8.474-9.222c-3.089-1.067-7.976-1.246-8.972 5.483-.777 1.58-7.228.25-7.228.25l-3.49.747-19.69 27.915 10.967 13.21L115.97 218.3l.666-8.049 4.707 5.263c1.569.201 3.064.22 4.486-.499l13.29 14.835-2.213 2.159c.748.83 1.262 1.361 2.01 2.192.748-.498 1.462-1.097 2.21-1.596.25.334.665.965.914 1.298-1.113.606-1.895 1.413-3.008 2.018-1.782-1.161-3.503-2.607-3.372-4.909l-7.477 6.23-.25 1.247-22.182 18.444-1.994.25-.498 5.732 14.455-11.963v-1.746l1.496 1.246 11.215-8.971s.748.996.5.996c-.25 0-9.97 8.973-9.97 8.973l-.25.996-1.745 1.496-.997-.748-13.459 11.964h-1.994l-7.477 7.478c-1.928.167-3.6.371-5.234 1.494l-13.393 11.825z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 1.068
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMz);
export default __webpack_public_path__ + "static/media/mz.44d9c5ca45e9e3665776b92d94cab007.svg";
export { ForwardRef as ReactComponent };